import React from 'react';
import './api-document.css'
import CommonImage from '../CommonComponent/CommonImage';
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';
import { isMobile } from 'react-device-detect';

const DocumentAPI = (props) => {

  const openDocument = () => {
    window.open(`${(props.fields.link.value.href).toLowerCase()}`, '_blank')
  }

    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //----------------------------------------------

  return (
    <div className="swagger-document-link">
      <a onClick={openDocument}>
        <CommonImage imageIcon={props.fields.icon.value.src}/>
          {!isMobile && <span>API Documentation</span>}
    </a>
    </div>
  )
};

export default DocumentAPI;
